export const theme = {
  colors: {
    primary: 'hotpink',
  },
};
